import React from 'react'

import { Filter } from '@cubejs-client/core'
import { MEETINGS_DIMENSIONS } from 'cube'

import { Flex } from '@driftt/dds'

import WhoBookedMeetingsChart from 'components/meeting/WhoBookedMeetingsChart'
import { KPICards } from 'components/SiteConciergeMeetings'
import { MeetingBookingReportFeedbackModal } from 'components/SiteConciergeMeetings/MeetingBookingReportFeedbackModal'
import MeetingOutcomesChart from 'components/SiteConciergeMeetings/MeetingOutcomesChart/MeetingOutcomesChart'
import { withCubeReportsLayout } from 'layouts/CubeReportsLayout'
import { ReportPage } from 'types/pages'

const siteConciergeFilters = [
  {
    member: MEETINGS_DIMENSIONS.MEETING_SOURCE,
    operator: 'equals',
    values: ['SITE_CONCIERGE'],
  },
] as Filter[]

const SiteConciergeMeetings = () => {
  return (
    <Flex direction="column" gap={3} fullWidth>
      <Flex.Item alignSelf="stretch">
        <KPICards />
      </Flex.Item>
      <Flex.Item alignSelf="stretch">
        <MeetingOutcomesChart />
      </Flex.Item>
      <Flex.Item alignSelf="stretch">
        <WhoBookedMeetingsChart
          metric="meetingsBooked"
          filters={siteConciergeFilters}
        />
      </Flex.Item>
    </Flex>
  )
}

export default withCubeReportsLayout(
  ReportPage.SiteConcierge,
  true,
  true,
  <MeetingBookingReportFeedbackModal />
)(SiteConciergeMeetings)
